enum DealSegment {
  InstantQuote = 1,
  RangeQuote = 2,
}

export default DealSegment;
